<template>
  <div>
    <login-form />
  </div>
</template>

<script>
import loginForm from "../components/login/LoginForm";

export default {
  components: {
    loginForm
  }
};
</script>
